/**
 * INBAR+co — Journal Index JS
 * File: assets/inbar-journal.js
 * Handles filter active-state from URL tag parameter
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ── FILTER — mark active tag from URL path ── */
    var path = window.location.pathname;
    var tagMatch = path.match(/\/tagged\/([^/]+)/);
    if (tagMatch) {
      var activeSlug = tagMatch[1];
      document.querySelectorAll('.ic-jnl__filter-tag').forEach(function (el) {
        var href = el.getAttribute('href') || '';
        if (href.indexOf(activeSlug) !== -1) {
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
        }
      });
    }

  });
})();
